import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableBatchPrescreenApplication = loadable(
  () => import('./FallbackApplication'),
  { fallback: <LoadingScreen /> },
);

export default LoadableBatchPrescreenApplication;
